import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form206Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        medicaidReleaseConsent: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .nullable()
            .refine((consent): boolean => consent === 'true' || consent === 'false', {
                message: `${t('requiredErrorFull')}`,
            })
            .transform(str => str === 'true'),
    });
